
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accommodation/find-a-home/[residence]",
      function () {
        return require("private-next-pages/accommodation/find-a-home/[residence].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accommodation/find-a-home/[residence]"])
      });
    }
  